import React, {useEffect, useState} from 'react'
import useProductUsageHistoryStyles from 'pages/ProductUsageHistory/style'
import CardWithTitle from 'components/atoms/CardWithTitle'
import {
  LIST_TABS,
  ACTIVE_PRODUCT,
  DISCONTINUED_PRODUCT,
} from 'pages/ProductUsageHistory/constant'
import {useTranslation} from 'react-i18next'
import {Button} from '@material-ui/core'
import useProductInstitutionOperationHistory from 'features/productInstitutionOperationHistory/useProductInstitutionOperationHistory'
import ActiveProduct from 'pages/ProductUsageHistory/Component/ActiveProduct'
import NotActiveProduct from 'pages/ProductUsageHistory/Component/NotActiveProduct'
import useProductManagement from 'features/productManagement/useProductManagement'
import {useParams} from 'react-router-dom'
import {getDetailOrgRegister} from 'api/invoiceApis'

const ProductInstitutionOperationHistory = () => {
  const classes = useProductUsageHistoryStyles()
  const {t} = useTranslation()
  const {orgId} = useParams<{orgId: string}>()
  const [activeTabs, setActiveTabs] = useState<number>(0)
  const [orgName, setOrgName] = useState('')
  const {fetchLicenseWithItem, listActive, listDiscontinue} =
    useProductInstitutionOperationHistory()

  const {getAllPackageList} = useProductManagement()

  const getOrgLicense = () => {
    const orgIdParams = new URLSearchParams({orgIds: String(orgId)})
    fetchLicenseWithItem(orgIdParams)
  }

  const getOrgName = async () => {
    const orgRes = await getDetailOrgRegister(Number(orgId))
    setOrgName(`${orgRes.data.orgName} (${orgRes.data.email})`)
  }

  useEffect(() => {
    getOrgLicense()
    getOrgName()
    getAllPackageList()
    setActiveTabs(ACTIVE_PRODUCT)
  }, [])

  return (
    <CardWithTitle title={t('IProductInstitutionOperationHistory')}>
      <div className={classes.orgName}>{orgName}</div>
      <div className={classes.tabsUnderline}>
        {LIST_TABS.map((item) => (
          <div key={item.id}>
            <Button
              onClick={() => setActiveTabs(item.id)}
              className={`${classes.tabUnderline} ${
                activeTabs === item.id ? classes.activeTabs : ''
              }`}
            >
              {t(item.label)}
            </Button>
            {activeTabs === item.id && <div className={classes.active} />}
          </div>
        ))}
        <div className={classes.underlineIndicator} />
      </div>
      {activeTabs === ACTIVE_PRODUCT && (
        <ActiveProduct
          isAdmin
          data={listActive}
          orgName={orgName}
          onUpdateLog={getOrgLicense}
        />
      )}
      {activeTabs === DISCONTINUED_PRODUCT && (
        <NotActiveProduct
          isAdmin
          data={listDiscontinue}
          onUpdateLog={getOrgLicense}
        />
      )}
    </CardWithTitle>
  )
}

export default ProductInstitutionOperationHistory
